import i18n from '@/locales'

export default {
  data () {
    return {
      invoiceInfoProps: {
        list: this.$list.createList(this, {
          resource: 'billing_invoice_info',
        }),
        columns: [
          {
            field: 'invoice_type',
            title: i18n.t('scope.text_746'),
            minWidth: 80,
            formatter: ({ cellValue }) => {
              const obj = {
                ordinary: i18n.t('scope.text_721'),
                special: i18n.t('scope.text_722'),
                ngo: i18n.t('scope.text_723'),
              }
              return obj[cellValue]
            },
          },
          {
            field: 'title',
            title: i18n.t('scope.text_747'),
            minWidth: 100,
          },
          {
            field: 'register_no',
            title: i18n.t('scope.text_748'),
            minWidth: 100,
          },
          {
            field: 'bank_name',
            title: i18n.t('scope.text_749'),
            minWidth: 100,
          },
          {
            field: 'status',
            title: i18n.t('scope.text_426'),
            minWidth: 70,
          },
        ],
      },
    }
  },
}
